import { typedQueryClient, useTypedMutation } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

type MoneyIndicatorPayload = { is_money: boolean };

export const useAppointmentMoneyIndicatorMutation = (appointment_id: number) =>
  useTypedMutation<MoneyIndicatorPayload, void>({
    mutationFn: async payload => {
      await ApiInstance.post("/appointments/update_billing", { appointment_id, ...payload });
    },
    onSuccess: payload => {
      const appointment = typedQueryClient.getQueryData(AppointmentDetailsKeys.view);
      if (!appointment) return;

      typedQueryClient.setQueryData(AppointmentDetailsKeys.view, { ...appointment, ...payload });
    }
  });
